import {
  Button,
  Col,
  Form,
  FormControl,
  FormGroup,
  FormLabel,
  Modal,
  Row,
} from "@themesberg/react-bootstrap";
import React, { useEffect, useState } from "react";
import Invitations from "../../Shared/components/Table/Invitations";
import Navbar from "../../Shared/Navbar/Navbar";
import Preloader from "../../Shared/Preloader/Preloader";
import Sidebar from "../../Shared/Sidebar";
import LessSidebar from "../../Shared/LessSidebar";
import { useNavigate } from "react-router-dom";
import { currentUser } from "../../../authentication/auth";
import { APIURL } from "../../../configApi";

import { axiosInstance } from "../../../config/axios";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faPaperPlane,
  faPlusCircle,
  faShare,
} from "@fortawesome/free-solid-svg-icons";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import FirebaseNotif from "../../Shared/FirebaseNotif/FirebaseNotif";

export default function () {
  const [email, setEmail] = useState();
  const [showDefault, setShowDefault] = useState(false);
  const handleClose = () => setShowDefault(false);
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [invitations, setInvitations] = useState([]);
  const [page, setPage] = useState(1);
  useEffect(() => {
    if (currentUser() == null) {
      navigate("/login");
    } else {
      setUser(currentUser());
      getMyInvitations();
    }
  }, []);

  const getMyInvitations = () => {
    axiosInstance
      .get(`${APIURL}/global/request_invitations?page=${page}`)
      .then((res) => {
        setInvitations(res.data.data.list);
        // console.log(invitations);
      })
      .catch((err) => {
        // console.log(err);
      });
  };

  const sendNewInvitation = (e) => {
    e.preventDefault();
    axiosInstance
      .post(`${APIURL}/global/request_invitations`, { email: email })
      .then((res) => {
        NotificationManager.success(
          "Invitation envoye avec suces",
          "Notification"
        );
        setShowDefault(false);
        setEmail("");
        getMyInvitations();
        //console.log(invitations)
      })
      .catch((err) => {
        NotificationManager.error(err.response.data.message, "Notification");
        setEmail("");
      });
  };

  const [hideSidebar, setHideSidebar] = useState(
    JSON.parse(localStorage.getItem("sidebar-state"))
  );
  return (
    <>
      <Preloader />
      <div className={`content`}>
        {hideSidebar ? (
          <LessSidebar
            user={user}
            expand={() => {
              setHideSidebar(false);
              localStorage.setItem("sidebar-state", false);
            }}
          />
        ) : (
          <Sidebar
            user={user}
            expand={() => {
              setHideSidebar(true);
              localStorage.setItem("sidebar-state", true);
            }}
          />
        )}
      </div>
      {/* <FirebaseNotif /> */}
      <main className={`content ${hideSidebar ? "mleft-0" : ""}`}>
        <Navbar
          user={user}
          pageName={"Liste des invitations"}
          icon={faPaperPlane}
        />
        <hr />
        <div>
          <div className="text-end mb-3">
            <button
              className="btn btn-main"
              onClick={() => setShowDefault(true)}
            >
              <FontAwesomeIcon icon={faPlusCircle} /> Inviter{" "}
            </button>
          </div>
          <Row className="justify-content-md-center">
            {invitations.length > 0 && (
              <Invitations
                refreshInvitations={getMyInvitations}
                name={"Liste des invitations"}
                invitations={invitations}
                headColumns={[
                  "dentist",
                  "status",
                  "created_at",
                  "source_direction",
                ]}
                searched={false}
              />
            )}
          </Row>
        </div>

        <Modal
          as={Modal.Dialog}
          centered
          show={showDefault}
          onHide={handleClose}
          size={"lg"}
        >
          <Modal.Header>
            <Modal.Title className="h6">
              <FontAwesomeIcon icon={faEnvelope} /> Envoyer une nouvelle
              Invitation
            </Modal.Title>
            <Button variant="close" aria-label="Close" onClick={handleClose} />
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={sendNewInvitation}>
              <Row>
                <Col md={"10"}>
                  <FormGroup>
                    <FormControl
                      type={"email"}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder={"Email de dentiste ..."}
                    ></FormControl>
                  </FormGroup>
                </Col>
                <Col md={"2"}>
                  <FormGroup>
                    <Button type={"submit"} variant={"main"}>
                      <FontAwesomeIcon icon={faShare} /> Envoyer{" "}
                    </Button>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
        </Modal>

        <NotificationContainer />
      </main>
    </>
  );
}
